import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { FiSmsCostsComponent } from '@fi-app/sms/sms-costs/sms-costs.component';
import { FiSmsCostsSelectPeriodComponent } from '@fi-app/sms/sms-costs/select-period/select-period.component';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiSmsCostsListDataService } from '@fi-app/sms/sms-costs/sms-costs-list-data.service';
import { ItemsListModule } from '@fi-app/components/items-list/items-list.module';
import { MatCardModule } from '@angular/material/card';
import { FiWrapperTableModule } from '@fi-app/shared/fi-wrapper-table/fi-wrapper-table.module';
import { FiAppTextSharedModule } from '@fi-app/shared/app-text';

@NgModule({
    imports: [CommonModule, MatSelectModule, FiLoadingModule, ItemsListModule, MatCardModule, FiWrapperTableModule, FiAppTextSharedModule],
    declarations: [FiSmsCostsComponent, FiSmsCostsSelectPeriodComponent],
    exports: [FiSmsCostsComponent],
    providers: [FiSmsCostsListDataService],
})
export class FiSmsCostsModule {}
